import React, { Component } from 'react'
//import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Radium from 'radium'
import $ from 'jquery'

import TEHelmet from './../../../component/Header/TEHelmet'
import TESimpleEmail from './../../../component/Email/TESimpleEmail'
import { formatEmailString, sendEmail, isEmail } from './../../../helpers'
import '../../../stylesheets/home.css'

import images from '../../../config/images'
import styles from './styles'

class Home extends Component {
	state = {
		callToActionPopup: false,
		formSubmitting: false,
		fName: '',
		lName: '',
		message: '',
		emailAddress: '',
	}
	componentDidMount() {
		this._isMounted = true
		scrollUpdate()
		setTimeout(() => {
			if (this._isMounted) {
				this.setState({ callToActionPopup: true })
			}
		}, 5000)

		//
		//Load All Images Async
		//
		var allImages = $('img[delayedsrc]')
		//Start All Images Loading
		allImages.each(function () {
			$(this).attr('src', $(this).attr('delayedsrc'))
		})

		$(window).scroll(function () {
			scrollUpdate()
		})

		function scrollUpdate() {
			if ($('#HOME_PAGE').length) {
				//Window Variables
				var windowTop = $(window).scrollTop()
				var windowHeight = $(window).height()
				var windowBottom = windowTop + windowHeight

				//Header Text
				var news = $('.header-txt')
				var newsBottom = news.offset().top + news.outerHeight() * 0.5

				if (windowBottom > newsBottom) {
					news.addClass('slide-in')
				}

				//Story
				var story = $('#story')
				var storyBottom = story.offset().top + story.outerHeight() * 0.5

				if (windowBottom > storyBottom) {
					story.addClass('fade-in')
				}

				//Community
				var community = $('#community')
				var communityBottom = community.offset().top + community.outerHeight() * 0.5

				if (windowBottom > communityBottom) {
					community.addClass('slide-in')
				}

				//Donate
				var donate = $('#donate')
				var donateBottom = donate.offset().top + donate.outerHeight() * 0.5

				if (windowBottom > donateBottom) {
					donate.addClass('slide-in')
				}

				//Donate
				var volunteer = $('#volunteer')
				var volunteerBottom = volunteer.offset().top + volunteer.outerHeight() * 0.5

				if (windowBottom > volunteerBottom) {
					volunteer.addClass('slide-in')
				}

				//Belt
				var belt = $('#belt')
				var beltBottom = belt.offset().top + belt.outerHeight() * 0.5

				if (windowBottom > beltBottom) {
					belt.addClass('slide-in')
				}

				//Sponsors
				var sponsors = $('#sponsors')
				var sponsorsBottom = sponsors.offset().top + sponsors.outerHeight() * 0.5

				if (windowBottom > sponsorsBottom) {
					sponsors.addClass('fade-in')
				}
				//else { definesUs.children().removeClass("fade-in"); }

				//Contact Tab
				var contactTab = $('#contact-tab')
				var contactTabBottom = contactTab.offset().top + contactTab.outerHeight() * 0.5

				if (windowBottom > contactTabBottom) {
					contactTab.addClass('slide-in')
				}

				//Contact form
				var contact = $('#contact')
				var contactBottom = contact.offset().top + contact.outerHeight() * 0.5

				if (windowBottom > contactBottom) {
					contact.addClass('fade-in')
				}
			}
		}
	}
	componentWillUnmount() {
		this._isMounted = false
	}
	contactFormSubmit = (event) => {
		event.preventDefault()
		this.setState({ formSubmitting: true })
		const { fName, lName, email, message } = this.state
		console.log(fName, lName, email, message)
		if (!fName || !lName || !email || !message) {
			alert('Please fill out all form inputs')
			this.setState({ formSubmitting: false })
			return
		} else if (!isEmail(email)) {
			alert('Invalid email address.')
			this.setState({ formSubmitting: false })
			return
		}

		const emailString = `Name: ${fName} ${lName}\r\n\r\nEmail: ${email}\r\n\r\nMessage: ${message}`

		const emailHTMLString = formatEmailString(
			<TESimpleEmail
				title='RPFPC Contact Form Message'
				body={
					<span style={{ whiteSpace: 'pre-line' }}>
						{' '}
						Name: {fName} {lName}
						<br />
						<br />
						Email: {email}
						<br />
						<br />
						Message: {message}
					</span>
				}
			/>,
		)

		const data = {
			bccEmailAddresses: [],
			ccEmailAdresses: [],
			toEmailAddresses: ['ProgramDirector@rpfpc.com'],
			subjectdata: 'RPFPC Contact Form',
			bodyData: emailString,
			htmlData: emailHTMLString,
			bodyCharset: 'UTF-8',
			subjestCharset: 'UTF-8',
			sourceEmail: '"38th Street Studios" <info@38thstreetstudios.com>',
			replyToAddresses: [email],
		}
		sendEmail(data)
			.then((response) => {
				this.setState({ formSubmitting: false })
				console.log(response)
				alert('Mail sent successfully.')
			})
			.catch((error) => {
				console.log(error)
				alert(error.alertMessage)
				this.setState({ formSubmitting: false })
			})
		console.log(data)
	}

	render() {
		const meta = {
			title: 'RPFPC',
			description: '',
		}

		return (
			<div id='HOME_PAGE'>
				<div style={styles.container}>
					<TEHelmet {...meta} />
					<header className='header' id='header'>
						<img
							src={images.rpfpc_header_image}
							alt='header'
							width='100%'
							height='100%'
							className='header-img'
						/>
						<div className='header-txt news' id='news'>
							<h2 className='header-title'>
								NEWS
								<img src={images.rpfpc_news_icon_home} alt='news' />
							</h2>
							<br />
							<h3 className='news-title'>RPFPC Is Doing Great Things!</h3>
							<br />
							<p className='header-body'>Read about some of our recent events.</p>
							<br />
							<div className='button-container'>
								<a href='/events' className='button'>
									READ MORE
								</a>
							</div>
						</div>
						<div className='header-txt membership' id='membership'>
							<h2 className='header-title'>CELEBRITY GOLF OUTING</h2>
							<br />
							<p className='header-body'>
								You are invited to RPFPC's 22st annual celebrity golf outing on
								Tuesday, July 14th. All proceeds will benefit our scholarship, youth
								grant and mentorship programs.
							</p>
							<br />
							<div className='button-container'>
								<a href='https://www.golfinvite.net/rpfpc' className='button'>
									LEARN MORE
								</a>
							</div>
						</div>
					</header>
					<div className='section story' id='story'>
						<div className='column left'>
							<h3>
								OUR STORY
								<div className='underline' />
							</h3>
						</div>
						<div className='column right'>
							<p>
								Founded in 2003, the Retired Professional Football Players of
								Chicago (RPFPC) is the charitable arm of the NFL Players
								Association, Former Players - Chicago Chapter. Established as a
								501(c)(3) not-for-profit organization, the RPFPC is comprised of
								former professional football players who work voluntarily to support
								Chicagoland causes and charities. RPFPC primarily aims to raise
								funds for its annual academic scholarship program and football
								equipment grant program for local youth.
							</p>
						</div>
					</div>
					<div className='community section' id='community'>
						<div className='white-background' />
						<div className='red-background'>
							<div className='black-inner' />
							<h2>COMMUNITY</h2>
							<h4>PARTNERSHIP OPPORTUNITIES</h4>
							<p>
								We offer unique and exciting opportunities to collaborate with
								former NFL players and celebrities through event sponsorship and
								other partnership avenues that are sure to drive business.
							</p>
							<a href='/programs' className='button'>
								LEARN MORE
							</a>
						</div>
					</div>
					<div className='donate section' id='donate'>
						<div className='column left'>
							<a href='https://www.ubackforgood.com/donate/index.php?charityid=166336'>
								<img src={images.uBack_Indigo_TM} alt='donate' title='donate' />
							</a>
							<a
								href='https://www.ubackforgood.com/donate/index.php?charityid=166336'
								className='button'
							>
								Donate Here
							</a>
						</div>
						<div className='column right'>
							<h2>DONATE</h2>
							<div className='subsection-container'>
								<div className='subsection'>
									<h4>ACADEMIC SCHOLARSHIP PROGRAM</h4>
									<p>
										RPFPC's Scholarship Program provides high school
										student-athletes (one male and one female) with financial
										support as he/she pursues education at a collegiate
										institution that does not offer athletic scholarships.
									</p>
									<a href='/programs' className='button'>
										LEARN MORE
									</a>
								</div>
								<div className='subsection right'>
									<h4>FOOTBALL EQUIPMENT GRANT PROGRAM</h4>
									<p>
										RPFPC's Football Equipment Grant Program provides local
										youth programs with safe and proper playing gear. The grant
										is annually awarded to three youth or high school football
										programs that are in need of new equipment.
									</p>
									<a href='/programs' className='button'>
										LEARN MORE
									</a>
								</div>
							</div>
						</div>
						<div className='column left mobile'>
							<a href='https://www.ubackforgood.com/donate/index.php?charityid=166336'>
								<img src={images.uBack_Indigo_TM} alt='donate' title='donate' />
							</a>
							<a
								href='https://www.ubackforgood.com/donate/index.php?charityid=166336'
								className='button'
							>
								Donate Here
							</a>
						</div>
					</div>
					<div className='volunteer section' id='volunteer'>
						<div className='column left'>
							<h2>VOLUNTEER</h2>
							<img
								src='#'
								delayedsrc={images.volunteer2}
								alt='volunteer'
								title='volunteer'
							/>
							<div className='text'>
								<p>
									We welcome volunteers for our year-round community events and
									programs. Join us for a rewarding experience as we give back to
									the Chicagoland community and inspire a new generation of
									athletes and leaders.
								</p>
								<a href='/programs' className='button'>
									LEARN MORE
								</a>
							</div>
						</div>
						<div className='column right'>
							<img
								src='#'
								delayedsrc={images.volunteer}
								alt='volunteer'
								title='volunteer'
							/>
						</div>
					</div>
					<div className='belt section' id='belt'>
						<div className='white-background' />
						<div className='red-left'>
							<div className='white-line'>
								<div className='red-inside'>
									<img
										src='#'
										delayedsrc={images.bar1}
										alt='volunteer'
										title='volunteer'
									/>
									<img
										src='#'
										delayedsrc={images.bar2}
										alt='volunteer'
										title='volunteer'
									/>
									<img
										src='#'
										delayedsrc={images.bar3}
										alt='volunteer'
										title='volunteer'
									/>
								</div>
							</div>
						</div>
						<div className='red-right'>
							<div className='white-line'>
								<div className='red-inside'>
									<img
										src='#'
										delayedsrc={images.bar4}
										alt='volunteer'
										title='volunteer'
									/>
									<img
										src='#'
										delayedsrc={images.bar6}
										alt='volunteer'
										title='volunteer'
									/>
									<img
										src='#'
										delayedsrc={images.bar5}
										alt='volunteer'
										title='volunteer'
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='section sponsors' id='sponsors'>
						<div className='column left'>
							<h3>
								OUR SPONSORS
								<div className='underline' />
							</h3>
						</div>
						<div className='column right'>
							<div className='sponsor primus'>
								<a href='http://primuselectronics.com/'>
									<img
										src='#'
										delayedsrc={images.Primus_NEW_tile}
										alt='primus electronics'
										title='Primus Electronics'
									/>
								</a>
							</div>
							<div className='sponsor thd'>
								<a href='http://www.homedepot.com/'>
									<img
										src='#'
										delayedsrc={images.THD_logo}
										alt='the home depot'
										title='The Home Depot'
									/>
								</a>
							</div>
							<div className='sponsor'>
								<a href='http://t-squaredbuilders.com/'>
									<img
										src='#'
										delayedsrc={images.tSquaredLogo}
										alt='t-squared builders'
										title='T-Squared Builds'
									/>
								</a>
							</div>
							<div className='sponsor'>
								<a href='http://www.wilson.com/en-us'>
									<img
										src='#'
										delayedsrc={images.wilson_logo}
										alt='wilson'
										title='Wilson'
									/>
								</a>
							</div>
						</div>
					</div>
					<div className='section contact-tab' id='contact-tab'>
						<div className='white-background' />
						<div className='red-background'>
							<div className='black-inner' />
							<h2>CONTACT US</h2>
							<div className='icons'>
								<a
									href='https://www.facebook.com/rpfpchicago'
									className='social-link'
								>
									<img
										src={images.social.facebook}
										alt='facebook'
										title='Facebook'
									/>
								</a>
								<a
									href='https://www.twitter.com/retirednflchi'
									className='social-link'
								>
									<img
										src={images.social.twitter}
										alt='twitter'
										title='Twitter'
									/>
								</a>
							</div>
							<p>
								Please feel free to email with us with any questions you may have.
							</p>
						</div>
					</div>
					<div className='section contact' id='contact'>
						<form
							className='contact-form'
							name='contactForm'
							onSubmit={this.contactFormSubmit}
						>
							<div className='form-row half left'>
								<label htmlFor='first-name'>First Name</label>
								<input
									type='text'
									name='firstName'
									placeholder='first name'
									onChange={(event) => {
										this.setState({ fName: event.target.value })
									}}
									id='first-name'
									disabled={this.state.formSubmitting}
								/>
							</div>
							{}

							<div className='form-row half right'>
								<label htmlFor='last-name'>Last Name</label>
								<input
									type='text'
									name='lastName'
									placeholder='last name'
									onChange={(event) => {
										this.setState({ lName: event.target.value })
									}}
									id='last-name'
									disabled={this.state.formSubmitting}
								/>
							</div>
							<div className='form-row'>
								<label htmlFor='email'>Email</label>
								<input
									type='text'
									name='email'
									placeholder='email address'
									onChange={(event) => {
										this.setState({ email: event.target.value })
									}}
									id='email'
									disabled={this.state.formSubmitting}
								/>
							</div>
							<div className='form-row'>
								<label htmlFor='message'>Message</label>
								<textarea
									name='message'
									placeholder='message'
									onChange={(event) => {
										this.setState({ message: event.target.value })
									}}
									id='message'
									disabled={this.state.formSubmitting}
									defaultValue={''}
								/>
							</div>
							<div className='form-row' id='recaptcha' />
							<div className='form-row'>
								<button
									type='submit'
									className='submit-button'
									disabled={this.state.formSubmitting}
								>
									Send Message
								</button>
							</div>
						</form>
					</div>

					{this.state.callToActionPopup && (
						<div className='call-to-action-popup'>
							<div className='content'>
								<div className='title'>
									<span className='name'>RPFPC</span>
									Chapter Events
									<div className='nflpa-logo'>
										<span>Supported By </span>
										<img
											src={images.NFLPA_Chicago_Logo}
											alt='NFLPA Chicago Logo'
											title='NFLPA Chicago Logo'
										/>
									</div>
								</div>
								<div className='close'>
									<button
										type='button'
										onClick={() => {
											this.setState({ callToActionPopup: false })
										}}
									>
										X
									</button>
								</div>
								<div className='content-container'>
									<div className='body'>
										<div className='title'>2021 Youth Football Grant</div>
										<div className='message'>
											We are now accepting applications for our 2021 RPFPC
											Youth Football Grants
										</div>
										<a href='/programs' className='button'>
											More Details
										</a>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		)
	}
}

Home.propTypes = {}

const mapStateToProps = (state) => {
	return {}
}

export default connect(mapStateToProps, {})(Radium(Home))
